module.exports = __webpack_public_path__ + "static/media/IBAlogo.0702ef52.svg";